import _implicitStylesheets from "./pluginSidebar.css";
import _implicitScopedStylesheets from "./pluginSidebar.scoped.css?scoped=true";
import _listingHarnessIcon from "listing/harnessIcon";
import _wdsButton from "wds/button";
import _listingGuidedInstallModal from "listing/guidedInstallModal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="external-install-description${0}" type-style="body-2"${2}>${"t1"}</p>`;
const stc0 = {
  classMap: {
    "install-box": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "install-heading": true
  },
  attrs: {
    "type-style": "display-7"
  },
  key: 1
};
const stc2 = {
  "install-heading-icon": true
};
const stc3 = {
  "external-install-action": true
};
const stc4 = {
  "data-testid": "external-install-button"
};
const stc5 = {
  classMap: {
    "install-actions": true
  },
  key: 6
};
const stc6 = {
  "primary-install-action": true
};
const stc7 = {
  "data-testid": "get-install-prompt-button"
};
const stc8 = {
  "data-testid": "cli-script-button"
};
const stc9 = {
  "view-source-action": true
};
const stc10 = {
  "data-testid": "view-source-button"
};
const stc11 = {
  classMap: {
    "more-options": true
  },
  key: 10
};
const stc12 = {
  "more-options-toggle": true
};
const stc13 = {
  "data-testid": "more-options-toggle"
};
const stc14 = {
  "install-actions": true
};
const stc15 = {
  "data-testid": "secondary-cli-script-button"
};
const stc16 = {
  "data-id": "install-prompt-modal"
};
const stc17 = {
  "data-id": "cli-script-modal"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, t: api_text, h: api_element, sp: api_static_part, st: api_static_fragment, b: api_bind, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9} = $ctx;
  return [api_element("div", stc0, [api_element("h3", stc1, [$cmp.singleHarnessId ? api_custom_element("listing-harness-icon", _listingHarnessIcon, {
    classMap: stc2,
    props: {
      "installMethodId": $cmp.singleHarnessId
    },
    key: 2
  }) : null, api_text(api_dynamic_text($cmp.headingLabel))]), $cmp.isExternalInstall ? $cmp.showRequestBetaAccessCopy ? api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.requestBetaAccessDescription))]) : null : null, $cmp.isExternalInstall ? $cmp.hasExternalInstallUrl ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc3,
    attrs: stc4,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.externalInstallLabel,
      "ariaLabel": $cmp.externalInstallAriaLabel,
      "name": "external-install",
      "href": $cmp.externalInstallUrl,
      "target": $cmp.externalInstallTarget
    },
    key: 5,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleExternalInstallAnalytics))
    }
  }) : null : null, $cmp.showNativeInstallUi ? api_element("div", stc5, [$cmp.isPrimaryPrompt ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc7,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.getInstallPromptLabel,
      "icon": "copy",
      "name": "get-install-prompt"
    },
    key: 7,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleGetInstallPrompt)),
      "analytics": _m2 || ($ctx._m2 = api_bind($cmp.handleGetInstallPromptAnalytics))
    }
  }) : null, $cmp.isPrimaryCli ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc8,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.cliScriptLabel,
      "icon": "apex",
      "name": "cli-script"
    },
    key: 8,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleCliScript)),
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleCliScriptAnalytics))
    }
  }) : null, $cmp.hasSourceUrl ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc9,
    attrs: stc10,
    props: {
      "variant": "tertiary",
      "label": $cmp.viewOnGitHubLabel,
      "icon": "new_window",
      "name": "view-source",
      "href": $cmp.sourceUrl,
      "target": "_blank"
    },
    key: 9,
    on: {
      "analytics": _m5 || ($ctx._m5 = api_bind($cmp.handleViewSourceAnalytics))
    }
  }) : null]) : null, $cmp.showNativeInstallUi ? $cmp.hasSecondaryCli ? api_element("div", stc11, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc12,
    attrs: stc13,
    props: {
      "variant": "tertiary",
      "label": $cmp.moreOptionsLabel,
      "icon": $cmp.moreOptionsIcon,
      "iconPlacement": "end",
      "name": "more-options",
      "ariaExpanded": $cmp.moreOptionsAriaExpanded,
      "ariaControls": api_scoped_id("more-options-panel")
    },
    key: 11,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleToggleMoreOptions)),
      "analytics": _m7 || ($ctx._m7 = api_bind($cmp.handleMoreOptionsAnalytics))
    }
  })]) : null : null, $cmp.showNativeInstallUi ? $cmp.hasSecondaryCli ? api_element("div", {
    classMap: stc14,
    attrs: {
      "hidden": $cmp.moreOptionsCollapsed ? "" : null,
      "id": api_scoped_id("more-options-panel"),
      "data-testid": "more-options-panel"
    },
    key: 12
  }, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc15,
    props: {
      "variant": "secondary",
      "width": "fill",
      "label": $cmp.cliScriptLabel,
      "icon": "apex",
      "name": "cli-script"
    },
    key: 13,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.handleCliScript)),
      "analytics": _m9 || ($ctx._m9 = api_bind($cmp.handleCliScriptAnalytics))
    }
  })]) : null : null]), $cmp.showNativeInstallUi ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc16,
    props: {
      "listing": $cmp.listing,
      "installMethodId": "claude-code"
    },
    key: 14
  }) : null, $cmp.showNativeInstallUi ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc17,
    props: {
      "listing": $cmp.listing,
      "installMethodId": "claude-code",
      "mode": "cli"
    },
    key: 15
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-33negcvjk21";
tmpl.legacyStylesheetToken = "undefined-_pluginSidebar";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
